import { useState } from "react";
import { validateName, validateMobile, validateDecimal, validateNamewithNumber, validatePassword, validateAddress, validateNamewithoutSpace, validateFabricContent } from "./validators";

function useInputValidation() {
    const [errors, setErrors] = useState({ name: "", mobile: "", cname: "", phoneno: "", sname: "", rname: "", stock: "", mname: "", colorname: "", address: "", username: "", password: "" });

    const handleChange = (e) => {
        const { name, value } = e.target;

        let isValid = true;
        let errorMessage = "";

        if (name === "name" || name === "cname" || name === "sname" || name === "rname") {
            isValid = validateName(value);
            errorMessage = isValid ? "" : "Name must contain only letters and spaces.";
        }

        if (name === "colorname" || name === "mname") {
            isValid = validateNamewithNumber(value);
            errorMessage = isValid ? "" : "Name must contain only letters , numbers and spaces.";
        }

        if (name === "username") {
            isValid = validateNamewithoutSpace(value);
            errorMessage = isValid ? "" : "Name must contain only letters and numbers ";
        }


        if (name === "mobile" || name === "phoneno") {
            isValid = validateMobile(value);
            errorMessage = isValid ? "" : "Mobile number must start with 6-9 and be exactly 10 digits.";
        }

        if (name === "password") {
            isValid = validatePassword(value);
            errorMessage = isValid ? "" : "Password must contain at least one letter and one number. No spaces allowed.";
        }

        if (name === "address") {
            isValid = validateAddress(value);
            errorMessage = isValid ? "" : "Invalid address. Please enter a valid address ";
        }

        if (name === "stock") {
            isValid = validateDecimal(value);
            errorMessage = isValid ? "" : "Matches numbers with up to 3 decimal places";
        }
        // Inside handleChange
        if (name === "fabric_content") {
            isValid = validateFabricContent(value);
            errorMessage = isValid ? "" : "Fabric content must contain letters.";
        }

        setErrors((prevErrors) => ({ ...prevErrors, [name]: errorMessage }));
    };

    const resetErrors = () => {
        setErrors({ name: "", mobile: "", cname: "", phoneno: "", sname: "", rname: "", stock: "", mname: "", colorname: "", address: "", username: "", password: "" });
    };

    return {
        errors,
        handleChange,
        resetErrors,
    };
}

export default useInputValidation;
